export default "__VITE_ASSET__CN2_kYA___"